import {
  default as Dropdown,
  StatelessDropdown,
  useDropdownState,
} from './Dropdown'
import { DropdownItem, DropdownItemAnchor, DropdownItemNavLink } from './Item'
import DropdownDivider from './Divider'
import DropdownHeader from './Header'
import DropdownChevron from './DropdownChevron'
import DropdownChevrons from './DropdownChevrons'
import DropdownItemDescription from './DropdownItemDescription'
import { DropdownDownload } from './DropdownDownload'

export { StatelessDropdown, useDropdownState }
export { dropdownItemStyles } from './Item'
export { dropdownDividerStyles } from './Divider'
export * from './CardDropdown'

const Item = Object.assign(DropdownItem, {
  Anchor: DropdownItemAnchor,
  NavLink: DropdownItemNavLink,
})

export default Object.assign(Dropdown, {
  Item,
  ItemDescription: DropdownItemDescription,
  Download: DropdownDownload,
  Divider: DropdownDivider,
  Header: DropdownHeader,
  Chevron: DropdownChevron,
  Chevrons: DropdownChevrons,
})
